export default "__VITE_ASSET__CTSBJVKI__"